import { Route, Routes } from "react-router-dom";
import { NotFoundNotice } from "./components/NotFoundNotice";
import { CreatePage } from "./pages/CreatePage";
import { HomePage } from "./pages/HomePage";
import { ResultsPage } from "./pages/ResultsPage";
import { VotePage } from "./pages/VotePage";
import { Shell } from "./shell/Shell";

export function App() {
  return (
    <Shell>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/ny" element={<CreatePage />} />
        <Route path="/v/:voteId" element={<VotePage />} />
        <Route path="/r/:resultsId" element={<ResultsPage />} />
        <Route path="*" element={<NotFoundNotice what="siden" />} />
      </Routes>
    </Shell>
  );
}
